import React, { useCallback, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { cn } from 'helper/cn';

import moment from 'moment';

import Icons from '../../Icons';
import {
  createNewBoroadcast,
  updateNewBoroadcast,
} from '../../../../api/sequence';
import { updateInitialTrigger } from '../../../../api/sequence';
import { INITIAL_NEW_BROADCAST_DATA } from '../../../../constants/sequence';
import { formatUpdatedBroadcast } from '../../../../helpers/sequence/node';
import { convertToCustomFormat } from '../../../../../../helper/dateConverter';
import { formatTimeWithAmPm } from '../../../../../../helper/timeUtils';
import useToggle from '../../../../../../hooks/useToggle';
import { updateToggleToast } from '../../../../../../reduxToolkit/appSlice';
import {
  useAspDispatch,
  useAspSelector,
} from '../../../../../../test/jest-redux-hooks';
import Tick from '../../../../../../assets/customSVG/Tick';
import Xmark from '../../../../../../assets/customSVG/Xmark';
import Loader from '../../../../../../components/commonComponents/Loader/Index';
import Alert from '../../../../../../components/commonComponents/modals/Alert';

import Existing from './Existing';
import New from './New';

const initialDateAndTime = {
  date: '',
  selectedDate: '',
  selectedTime: '',
  hours: '12',
  minutes: '00',
  periods: 'PM',
};

export default function BroadcastTrigger({
  node,
  originalData,
  onChange,
  toggleNodeEditMode,
  allowToEditFlow,
  removeEdges,
  sequenceDetails,
}) {
  const { id, uniq_id, trigger_type, data, settings } = node;

  const { currentBrand, toggleToast } = useAspSelector((state) => state.app);
  const { sequence_id, campaign_id } = useParams();
  const dispatch = useAspDispatch();

  const [isOpen, setIsOpen] = useToggle(false);
  const [isUpdating, setIsUpdating] = useToggle(false);

  const [showConfirm, setShowConfirm] = useToggle();
  const [selectedBroadcast, setSelectedBroadcast] = useState(null);
  const [broadcastData, setBroadcastData] = useState({
    send: null,
    file: null,
    template: null,
    settings: null,
  });

  const [existingData, setExistingData] = useState(null);
  const [sendLatterDate, setSendLatterDate] = useState(initialDateAndTime);
  const [allowToRemoveEdges, setAllowToRemoveEdges] = useToggle(false);

  const [selectedTemplate, setSellectedTemplate] = useState(null);

  const typeStyles =
    'w-1/2 h-full min-h-9 flex items-center justify-center text-sm weight-medium rounded-lg cursor-pointer';

  const selected = useCallback(
    (value) =>
      value
        ? '!border text-[#6564CA] border-[#6564CA]'
        : '!border border-[#E8E8EA] text-[var(--contentText)]',
    [node]
  );

  useEffect(() => {
    if (!node?.settings?.defaults?.isExisting) {
      if (
        !sendLatterDate?.date &&
        node?.data?.settings?.send_setting === 'send_later'
      ) {
        const date = moment(node?.data?.settings?.send_later_dt).format(
          'DD MM YYYY hh mm A'
        );
        const splitDate = date.split(' ');

        setSendLatterDate({
          date: splitDate?.[0],
          selectedDate: `${splitDate?.[2]}-${splitDate?.[1]}-${splitDate?.[0]}`,
          selectedTime: `${splitDate?.[3]}:${splitDate?.[4]} ${splitDate?.[5]}`,
          hours: splitDate?.[3],
          minutes: splitDate?.[4],
          periods: splitDate?.[5],
        });
      }
    } else {
      resetSendLaterDate();
    }
  }, []);

  useEffect(() => {
    const isTemplateExist =
      node?.data?.settings?.template_name && node?.data?.settings?.template_id;
    if (!selectedTemplate && isTemplateExist) {
      setSellectedTemplate({
        id: node?.data?.settings?.template_id,
        name: node?.data?.settings?.template_name,
        language: node?.data?.settings?.template_language,
        subcategory_type: node?.data?.settings?.template_subcategory_type,
        category: node?.data?.settings?.template_category,
      });
    }
  }, [node]);

  useEffect(() => {
    if (
      node?.data?.broadcast &&
      (!selectedBroadcast || selectedBroadcast?.length === 0)
    )
      setSelectedBroadcast(node?.data?.broadcast);

    // if (!existingData) {
    //   setExistingData(node?.data);
    //   if (node?.data?.broadcast?.settings?.send_setting === 'send_later')
    //     resetSendLaterDate();
    // }
  }, [node]);

  const resetSendLaterDate = () => setSendLatterDate(initialDateAndTime);

  const onSelectType = useCallback(
    (type) => {
      const date = moment() < moment(sequenceDetails?.start_date);

      const isExisting = type === 'existing' ? true : false;

      if (node?.status !== 'UN_SAVED') {
        if (isExisting === originalData?.settings?.defaults?.isExisting) {
          const updatedData = formatUpdatedBroadcast({ node: originalData });
          onChange({
            type: 'UPDATE_NODE',
            id: node?.uniq_id,
            key: 'data',
            data: updatedData?.data,
          });
        } else {
          if (type === 'existing')
            onChange({
              type: 'UPDATE_NODE',
              id: node?.uniq_id,
              key: 'data',
              data: { broadcast_id: '' },
            });
          else
            onChange({
              type: 'UPDATE_NODE',
              id: node?.uniq_id,
              key: 'data',
              data: {
                settings: {
                  segment_mode: 'individual',
                  send_setting: date ? 'send_later' : 'send_now',
                  send_later_dt: date ? '' : 'send_now',
                },
              },
            });
        }
      }

      onChange({
        type: 'UPDATE_NODE',
        id: node?.uniq_id,
        primaryKey: 'settings',
        secondaryKey: 'defaults',
        key: 'isExisting',
        data: type === 'existing' ? 'true' : 'false',
      });
    },
    [node, originalData]
  );

  const chackNewBroadcastChanges = useCallback(() => {
    const newData = {
      isExisting: data?.isExisting,
      file: data?.data?.file,
      fileUrl: data?.data?.fileUrl,
      sendFrom: data?.data?.sendFrom,
      template: data?.data?.template,
      settings: data?.data?.settings,
    };

    const compare =
      JSON.stringify(newData) === JSON.stringify(INITIAL_NEW_BROADCAST_DATA);

    return compare;
  }, [data]);

  const createQuickBroadcast = async () => {
    const date = convertToCustomFormat(new Date());
    const name = `${sequenceDetails?.name}_broadcast_${date?.split('.')?.[0]}`;

    let payload = {
      brand_id: currentBrand?.brand_id,
      campaign_id: campaign_id,
      sequence_id,
      trigger_type: trigger_type?.toLowerCase(),
      name,
      ...data,
    };

    const res = await createNewBoroadcast(payload);

    if (res?.status === 200) {
      const payload = {
        brand_id: currentBrand?.brand_id,
        campaign_id: campaign_id,
        trigger_type: 'camp_wapp_bcast',
        save: true,
        details: {
          broadcast_id: res?.data?.id,
          start_broadcast_on_save: true,
        },
        defaults: node?.settings?.defaults,
        remove_edges: true,
      };

      const updatedTrigger = await updateInitialTrigger(
        sequence_id,
        node?.uniq_id,
        payload
      );

      if (updatedTrigger?.status === 200) {
        onChange({
          type: 'UPDATE_NODE_DATA',
          id: updatedTrigger?.data?.data?.[0]?.uniq_id,
          data: updatedTrigger?.data?.data?.[0],
        });

        toggleNodeEditMode({
          id: id,
          uniqId: uniq_id,
          defaults: settings?.defaults,
          key: 'isEditMode',
          value: 'false',
        });

        onChange({
          type: 'UPDATE_DATA',
          data: { selectedNode: null },
        });
      }
    } else {
      dispatch(
        updateToggleToast([
          ...toggleToast,
          {
            id: toggleToast?.length + 1,
            content: 'Broadcast creation failed',
            status: 'Error',
            duration: '',
          },
        ])
      );
    }
  };

  const updateQuickBroadcast = async () => {
    const settings = {
      ...data?.settings,
      segment_settings: [
        {
          ...data?.settings?.segment_settings?.[0],
          broadcast_part_id: data?.broadcast_part_id,
        },
      ],
    };

    delete settings?.template_language;

    let payload = {
      brand_id: currentBrand?.brand_id,
      campaign_id: campaign_id,
      settings,
    };

    // Build payload based on broadcast_part_type
    if (data?.broadcast_part_type === 'file_upload') {
      payload = {
        ...payload,
        broadcast_part_type: 'file_upload',
        broadcast_part_id: data?.broadcast_part_id,
        broadcast_file_data: data?.broadcast_file_data,
        file_path: data?.file_path,
        file_name: data?.file_name,
      };
    } else if (data?.broadcast_part_type === 'audience_set') {
      payload = {
        ...payload,
        broadcast_part_type: 'audience_set',
        broadcast_part_id: data?.broadcast_part_id,
        broadcast_file_data: data?.broadcast_file_data,
        audience_set_id: data?.audience_set_id,
      };
    }

    const res = await updateNewBoroadcast(data?.broadcast_id, payload);

    if (res?.status === 200) {
      const payload = {
        brand_id: currentBrand?.brand_id,
        campaign_id: campaign_id,
        trigger_type: 'camp_wapp_bcast',
        save: true,
        details: {
          broadcast_id: res?.data?.id,
          start_broadcast_on_save: true,
        },
        defaults: node?.settings?.defaults,
      };

      if (
        selectedTemplate &&
        data?.settings?.template_id !== selectedTemplate?.id
      )
        payload['remove_edges'] = true;
      else payload['remove_edges'] = false;

      const updatedTrigger = await updateInitialTrigger(
        sequence_id,
        node?.uniq_id,
        payload
      );

      if (updatedTrigger?.status === 200) {
        onChange({
          type: 'UPDATE_NODE_DATA',
          id: updatedTrigger?.data?.data?.[0]?.uniq_id,
          data: updatedTrigger?.data?.data?.[0],
        });

        toggleNodeEditMode({
          id: id,
          uniqId: uniq_id,
          defaults: settings?.defaults,
          key: 'isEditMode',
          value: 'false',
        });

        onChange({
          type: 'UPDATE_DATA',
          data: { selectedNode: null },
        });
      }
    } else {
      dispatch(
        updateToggleToast([
          ...toggleToast,
          {
            id: toggleToast?.length + 1,
            content: 'Broadcast creation failed',
            status: 'Error',
            duration: '',
          },
        ])
      );
    }
  };

  const handleYes = async () => {
    setIsUpdating(true);
    try {
      const allowToSubmit = showSubmit();

      if (allowToSubmit?.isExisting && allowToSubmit?.isAlreadySelected) {
        toggleNodeEditMode({
          id: node?.id,
          uniqId: node?.uniq_id,
          value: 'false',
          defaults: node?.settings?.defaults,
        });
      } else {
        try {
          let payload = {
            brand_id: currentBrand?.brand_id,
            campaign_id: campaign_id,
          };

          if (allowToSubmit?.isExisting) {
            payload = {
              ...payload,
              trigger_type: trigger_type?.toLowerCase(),
              save: true,
              remove_edges: true,
              details: {
                broadcast_id: selectedBroadcast?.id,
              },
            };

            const res = await updateInitialTrigger(sequence_id, node?.uniq_id, {
              ...payload,
              defaults: node?.settings?.defaults,
            });

            if (res?.status === 200) {
              setShowConfirm(false);
              onChange({
                type: 'UPDATE_NODE_DATA',
                id: node?.uniq_id,
                data: res?.data?.data?.[0],
              });

              onChange({
                type: 'UPDATE_DATA',
                data: { selectedNode: null },
              });
            } else {
              dispatch(
                updateToggleToast([
                  ...toggleToast,
                  {
                    id: toggleToast?.length + 1,
                    content: res?.response?.data?.message,
                    status: 'Error',
                    duration: '',
                  },
                ])
              );
            }
          } else {
            if (data?.broadcast_id) {
              await updateQuickBroadcast();
              if (
                selectedTemplate &&
                data?.settings?.template_id !== selectedTemplate?.id
              )
                removeEdges(node?.uniq_id);

              onChange({
                type: 'UPDATE_DATA',
                data: { selectedNode: null },
              });
            } else {
              await createQuickBroadcast();
              removeEdges(node?.uniq_id);
            }
          }

          setIsUpdating(false);
          // onChange({
          //   type: 'UPDATE_DATA',
          //   data: { selectedNode: null },
          // });
        } catch (error) {
          console.warn(error);
        }
      }
    } catch (error) {
      console.warn(error);
    }
  };

  const handleBroadcastData = ({ key, value }) => {
    const data = { ...broadcastData };
    data[key] = value;
    setBroadcastData(data);
  };

  const showSubmit = useCallback(() => {
    const isExisting = node?.settings?.defaults?.isExisting ? true : false;

    const isAlreadySelected =
      selectedBroadcast?.id === node?.data?.broadcast?.id;

    // New validation logic based on broadcast_part_type
    const isFileUploadValid =
      node?.data?.broadcast_part_type === 'file_upload' &&
      node?.data?.file_name &&
      node?.data?.file_path &&
      node?.data?.settings?.template_name &&
      node?.data?.settings?.template_id &&
      node?.data?.settings?.send_from_phone_name &&
      node?.data?.settings?.send_from_phone_number &&
      node?.data?.settings?.send_from_phone_number_id;

    const isAudienceSetValid =
      node?.data?.broadcast_part_type === 'audience_set' &&
      node?.data?.audience_set_id &&
      node?.data?.broadcast_file_data?.valid_count > 0 &&
      node?.data?.settings?.template_name &&
      node?.data?.settings?.template_id &&
      node?.data?.settings?.send_from_phone_name &&
      node?.data?.settings?.send_from_phone_number &&
      node?.data?.settings?.send_from_phone_number_id;

    const isNewDataIsValid = isFileUploadValid || isAudienceSetValid;

    const isValidSendSenttings =
      node?.data?.settings?.send_setting === 'send_later'
        ? node?.data?.settings?.send_later_dt !== ''
        : true;

    const isSendSettingValid = true;

    return {
      isExisting,
      isAlreadySelected,
      allow: isExisting
        ? isAlreadySelected
          ? true
          : selectedBroadcast
        : isNewDataIsValid && isSendSettingValid && isValidSendSenttings,
    };
  }, [node, selectedBroadcast]);

  return (
    <div className='w-full flex-1 min-w-full max-w-[17rem] h-full rounded-2xl overflow-hidden select-none'>
      <div className=''>
        <div
          className={cn(
            'flex items-center justify-between gap-5 px-5 py-2.5 bg-[#04B8A2] text-white'
          )}>
          <div className='flex items-center gap-5'>
            <Icons
              keyProp={node?.label?.toLowerCase()}
              bgProp={'transparent'}
            />
            <p className='capitalize'>{node?.label}</p>
          </div>
          <div
            className='size-4 flex items-center justify-center cursor-pointer'
            onClick={() => {
              toggleNodeEditMode({
                id: node?.id,
                uniqId: node?.uniq_id,
                value: 'false',
                defaults: node?.settings?.defaults,
              });
              onChange({
                type: 'UPDATE_NODE',
                id: node?.uniq_id,
                key: 'data',
                data: node?.status === 'NEW' ? null : originalData?.data,
              });
            }}>
            <Xmark
              color='white'
              width={12}
              height={12}
            />
          </div>
        </div>

        <div className='w-full px-6 pt-6 pr-1 bg-white'>
          <div className='w-full max-h-[400px] pr-6 flex flex-col gap-5 overflow-y-scroll listScroll'>
            <p>Select or create broadcast for your sequence.</p>
            <div className='w-full h-9 flex items-center'>
              <div
                className={cn(
                  typeStyles,
                  'border-r-0 rounded-r-none',
                  selected(node?.settings?.defaults?.isExisting)
                )}
                onClick={() => {
                  onSelectType('existing');
                }}>
                Existing
              </div>
              <div
                className={cn(
                  typeStyles,
                  'rounded-l-none border-l-0',
                  selected(!node?.settings?.defaults?.isExisting)
                )}
                onClick={() => {
                  onSelectType('new');
                }}>
                Create New
              </div>
            </div>
            {node?.settings?.defaults?.isExisting ? (
              <Existing
                data={node}
                onChange={onChange}
                selectedBroadcast={selectedBroadcast}
                setSelectedBroadcast={setSelectedBroadcast}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                allowToEditFlow={allowToEditFlow}
                sequenceDetails={sequenceDetails}
              />
            ) : (
              <New
                data={node}
                onChange={onChange}
                sendLatterDate={sendLatterDate}
                setSendLatterDate={setSendLatterDate}
                allowToEditFlow={allowToEditFlow}
                resetSendLaterDate={resetSendLaterDate}
                selectedTemplate={selectedTemplate}
                setSellectedTemplate={setSellectedTemplate}
                sequenceDetails={sequenceDetails}
              />
            )}
          </div>
        </div>

        <div className='w-full h-fit flex justify-end px-6 py-2.5 bg-white'>
          <button
            className={cn(
              'w-14 h-8 bg-[var(--primary)] flex items-center justify-center text-white px-4 py-1 rounded-md',
              showSubmit()?.allow
                ? 'cursor-pointer opacity-100'
                : 'opacity-50 cursor-not-allowed'
            )}
            onClick={() => {
              if (showSubmit()?.allow) handleYes();
            }}>
            {isUpdating ? (
              <Loader
                Width={14}
                Height={14}
                loaderBg='white'
              />
            ) : (
              <div className='flex items-center justify-center gap-1.5'>
                <Tick
                  width='12'
                  height='10'
                  strokeWidth='2.5'
                  stroke='white'
                />
                <span>OK</span>
              </div>
            )}
          </button>
        </div>
      </div>
      <Alert
        open={showConfirm}
        setOpen={setShowConfirm}
        content='changes'
        yesContent='Ok'
        noContent='Cancel'
        handleNo={() => setShowConfirm(false)}
        handleYes={handleYes}
      />
    </div>
  );
}
